/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon24Solid = forwardRef('ArrowDCornerRightDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16 7.5A4.5 4.5 0 0 0 11.5 3h-9a1.5 1.5 0 1 0 0 3h9A1.5 1.5 0 0 1 13 7.5v10.129l-4.19-4.19a1.5 1.5 0 0 0-2.12 2.122l5.503 5.503a3.263 3.263 0 0 0 4.614 0l5.504-5.503a1.5 1.5 0 0 0-2.122-2.122L16 17.63V7.5Z" })));
});
